import React, { Component } from "react";
import { apiGetLanguagesList } from "../../utils/apis";
import { GlobalContext } from "../../utils/globalprovider";

import DialogInput from "./input";
class LanguageInput extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.state =
        {
            value: this.props.value,
            format: this.props.format,
            codec: this.props.codec,
            errmsg: this.props.errmsg,
            liste: [],
        }
        this.retourapi = this.retourapi.bind(this);
    }

    componentDidMount()
    {
        apiGetLanguagesList (this.retourapi);
    }

    componentMustRefresh()
    {
        apiGetLanguagesList (this.retourapi);
    }


    retourapi (data)
    {
        
        var newvalue = this.state.value;
        if (this.state.value != "")
        {
            var found = false;
            for (var i=0; i<data.length; i++)
            {
                if (data[i].code === this.state.value)
                {
                    found = true;
                    break;
                }
            }
            if ((!found)  && (this.props.value==="")) newvalue = "fr-FR";
        }
        this.setState ({value: newvalue, liste: data})

    }

    setErrorMsg(msg)
    {
        this.setState({errmsg:msg});
    }

    componentDidUpdate()
    {
        if (this.props.onChange) this.props.onChange();
    }

    setValue(text, codec="", format="")
    {
        this.setState({value:text,codec:codec,format:format})
    }


    getValue()
    {
        return this.state.value;
    }

    render()
    {
        var msg="";
        if (this.state.errmsg != "")
        {
            msg=(
                <span style={{borderRadius:"3px",marginLeft:"12px",color:"white", borderStyle:"solid", borderColor:"red", borderWidth:"1px"}}
                    >
                &nbsp;&nbsp;{this.state.errmsg}&nbsp;&nbsp;
                </span>
            )
        }

        var title = this.context.language=="fr"?"Langue : ":"Language :";
        var formatcodec =(<></>)
        if (this.props.format !=="")
        {
            title = (<></>);
            formatcodec = (
                <>

                <DialogInput
                    value = {this.state.codec}
                    disabled={false}
                    autoFocus = {true}
                    title = {"Codec " + this.props.title}
                    width = {this.props.width -5}
                    readOnly = {true}
                    
        
                />
        
                <br/>
                <DialogInput
                    value = {this.state.format}
                    disabled={false}
                    autoFocus = {true}
                    title = {"Format " + this.props.title}
                    width = {this.props.width -5}
                    readOnly = {true}/>
                    
                    

                </>

            )
        }

        
        return (<>
            <div className = "dialog-Input-Title">
            {title}{msg}
            </div>

            {formatcodec}
            <select className="dialog-Input-Datas" 
                id={"selectlanguage"} 
                value = {this.state.value}
                style = {{width: this.props.width, textAlign: "left"}}
                disabled={this.props.disabled || this.props.readOnly}
                onChange={e => this.setState({value:e.target.value})}
                >

                {this.state.liste.map((oneoption, index) => (
                    <option key={index} value={oneoption.code}>
                     &nbsp;{oneoption.code}&nbsp;-&nbsp;{oneoption.name}&nbsp;

                    </option>
                    ))}


            </select>


            
        </>);
    
    }

}
LanguageInput.defaultProps = 
{
    codec:"",
    format:"",
    value:"en",
    disabled: false,
    autoFocus: false,
    readOnly: false,
    disabled: false,
    errmsg: "",
}

export default LanguageInput;